import React from 'react'
import { isFeatureEnabled, serverData, hasTreatmentName } from '../utils'
import { Message } from '@paypalcorp/worldready-react'
import { SHOPPING_PRIVACY_FLOW, MERCHANT_DATA_PRIVACY, DATA_PRIVACY_HOME,
        DATA_PRIVACY_MANAGECOOKIES ,MERCHANT_DATA_PRIVACY_MANAGECOOKIES, DATA_PRIVACY_PROFILE_SEARCH,
         DATA_PRIVACY_HOME_PROFILE_SEARCH, MERCHANT_DATA_PRIVACY_BLOCKED_CONTACTS, DATA_PRIVACY_HOME_BLOCKED_CONTACTS
        } from '../constants/constants'
import { dataPrivacyConfig } from './data-privacy-data-platform'

const enabledForNative = serverData.isNative,
  isPublicProfile = serverData.isPublicProfile,
  isMerchantUser = serverData.isMerchantUser || false,
  enabledForPermission =
    !isMerchantUser && isFeatureEnabled('enabledForPermission'),
  enabledForManageCookies =
    isFeatureEnabled('enabledForManageCookies') && !enabledForNative,
  enabledForSearchPrivacy =
    hasTreatmentName('Trmt_Search_Privacy_Controls') &&
    isFeatureEnabled('enabledForSearchPrivacy') &&
    isPublicProfile,
  enabledForMarketing =
    !isMerchantUser && isFeatureEnabled('enabledForMarketing'),
  enabledForShopping =
    !isMerchantUser && isFeatureEnabled('enabledForShopping'),
  enabledForBlockedContacts =
    hasTreatmentName('Trmt_Blocked_Contacts_Controls') &&
    isFeatureEnabled('enabledForBlockedContacts'),
  enabledForManagePrivacySection =
    enabledForPermission ||
    enabledForManageCookies ||
    enabledForMarketing ||
    enabledForShopping ||
    enabledForSearchPrivacy ||
    enabledForBlockedContacts,
  isInFrame = serverData.isInFrame,
  subsectionComponent =
    serverData.selectedComponent === 'dw2' ? 'dw2' : 'default'


const linkClassName = 'nemo-subSection-header subSection-header'
const privacySections = [
  {
    sectionId: 'privacySection',
    sectionName: <Message id="privacy.sectionName" />,
    isEnabled: enabledForManagePrivacySection,
    enabledCountries: [],
    hasElmoTreatment: true,
    subSections: [
      {
        subSectionId: 'permissions',
        title: <Message id="privacy.permissions.title" />,
        desc: <Message id="privacy.permissions.desc" />,
        iconName: dataPrivacyConfig.permission[subsectionComponent].iconName,
        linkClass: linkClassName,
        hasElmoTreatment: true,
        featureEnabled: enabledForPermission, //rcs service
        navigateTo:
          '/myaccount/security/flow/permissions/thirdparty?flow=cmV0dXJuVXJsPS9teWFjY291bnQvcHJpdmFjeSZjYW5jZWxVcmw9L215YWNjb3VudC9wcml2YWN5',
        fptiClickData: {
          pgrp: DATA_PRIVACY_HOME,
          page: DATA_PRIVACY_HOME,
          link: 'permissions_given',
        },
      },
      {
        subSectionId: 'manageCookies',
        title: (
          <Message
            id={
              isMerchantUser
                ? 'privacy.merchant.cookies.title'
                : 'privacy.manageCookies.title'
            }
          />
        ),
        desc: <Message id="privacy.manageCookies.desc" />,
        iconName: !isMerchantUser
          ? dataPrivacyConfig.manageCookie[subsectionComponent].iconName
          : '',
        linkClass: linkClassName,
        hasElmoTreatment: true,
        featureEnabled: enabledForManageCookies, //rcs service
        navigateTo:
          isInFrame && isMerchantUser
            ? `/myaccount/privacy/cookiePrefs?inframe=${isInFrame}`
            : '/myaccount/privacy/cookiePrefs',
        fptiClickData: {
          pgrp: isMerchantUser ? MERCHANT_DATA_PRIVACY : DATA_PRIVACY_HOME,
          page: isMerchantUser ? MERCHANT_DATA_PRIVACY : DATA_PRIVACY_HOME,
          pglk: isMerchantUser
            ? MERCHANT_DATA_PRIVACY_MANAGECOOKIES
            : DATA_PRIVACY_MANAGECOOKIES,
          pgln: isMerchantUser
            ? MERCHANT_DATA_PRIVACY_MANAGECOOKIES
            : DATA_PRIVACY_MANAGECOOKIES,
          comp: isMerchantUser ? 'bizmanagenodeweb' : 'privacynodeweb',
          link: 'manage_cookies',
        },
        action: <Message id="privacy.merchant.action.manage" />,
      },
      {
        subSectionId: 'interestMarketing',
        title: <Message id="privacy.marketing.title" />,
        desc: <Message id="privacy.marketing.desc" />,
        iconName: dataPrivacyConfig.marketing[subsectionComponent].iconName,
        linkClass: linkClassName,
        hasElmoTreatment: true,
        featureEnabled: enabledForMarketing,
        modal: {
          name: 'interestMarketingModal',
        },
        fptiClickData: {
          pgrp: DATA_PRIVACY_HOME,
          page: DATA_PRIVACY_HOME,
          link: 'marketing_offers',
        },
      },
      {
        subSectionId: 'ppShopping',
        title: <Message id="privacy.shopping.title" />,
        desc: <Message id="privacy.shopping.desc" />,
        iconName: dataPrivacyConfig.shopping[subsectionComponent].iconName,
        linkClass: linkClassName,
        hasElmoTreatment: true,
        featureEnabled: enabledForShopping,
        navigateTo: SHOPPING_PRIVACY_FLOW,
        fptiClickData: {
          pgrp: DATA_PRIVACY_HOME,
          page: DATA_PRIVACY_HOME,
          link: 'pp_shopping',
        },
      },
      {
        subSectionId: 'searchPrivacy',
        title: <Message id="privacy.options.title" />,
        desc: <Message id="privacy.options.desc" />,
        iconName: !isMerchantUser
          ? dataPrivacyConfig.searchPrivacy[subsectionComponent].iconName
          : '',
        linkClass: linkClassName,
        hasElmoTreatment: true,
        featureEnabled: enabledForSearchPrivacy,
        navigateTo:
          isInFrame && isMerchantUser
            ? `/myaccount/privacy/profiles/search?inframe=${isInFrame}`
            : '/myaccount/privacy/profiles/search',
        fptiClickData: {
          pgrp: isMerchantUser ? MERCHANT_DATA_PRIVACY : DATA_PRIVACY_HOME,
          page: isMerchantUser ? MERCHANT_DATA_PRIVACY : DATA_PRIVACY_HOME,
          pglk: isMerchantUser
            ? DATA_PRIVACY_PROFILE_SEARCH
            : DATA_PRIVACY_HOME_PROFILE_SEARCH,
          pgln: isMerchantUser
            ? DATA_PRIVACY_PROFILE_SEARCH
            : DATA_PRIVACY_HOME_PROFILE_SEARCH,
          comp: isMerchantUser ? 'bizmanagenodeweb' : 'privacynodeweb',
          link: 'profiles_search',
        },
        action: <Message id="privacy.merchant.action.update" />,
      },
      {
        subSectionId: 'blockedContacts',
        title: <Message id="privacy.blockedContacts.title" />,
        desc: <Message id="privacy.blockedContacts.desc" />,
        iconName: !isMerchantUser
          ? dataPrivacyConfig.blockedContacts[subsectionComponent].iconName
          : '',
        linkClass: linkClassName,
        hasElmoTreatment: true,
        featureEnabled: enabledForBlockedContacts,
        navigateTo:
          isInFrame && isMerchantUser
            ? `/myaccount/transfer/homepage/contact-list/blocked-contacts?inframe=${isInFrame}`
            : '/myaccount/transfer/homepage/contact-list/blocked-contacts',
        fptiClickData: {
          pgrp: isMerchantUser ? MERCHANT_DATA_PRIVACY : DATA_PRIVACY_HOME,
          page: isMerchantUser ? MERCHANT_DATA_PRIVACY : DATA_PRIVACY_HOME,
          pglk: isMerchantUser
            ? MERCHANT_DATA_PRIVACY_BLOCKED_CONTACTS
            : DATA_PRIVACY_HOME_BLOCKED_CONTACTS,
          pgln: isMerchantUser
            ? MERCHANT_DATA_PRIVACY_BLOCKED_CONTACTS
            : DATA_PRIVACY_HOME_BLOCKED_CONTACTS,
          comp: isMerchantUser ? 'bizmanagenodeweb' : 'privacynodeweb',
          link: 'blocked_contacts',
        },
        action: <Message id="privacy.merchant.action.update" />,
      },
    ],
  },
]

export default privacySections
